/**
 * Marketing templates must include trackable links (UTM) via {{CTA_URL}} or explicit utm_* query params.
 */
export function templateHasUtmTracking(content: string): boolean {
  const trimmed = content.trim();
  if (!trimmed) {
    return false;
  }
  if (/\{\{CTA_URL\}\}/i.test(trimmed)) {
    return true;
  }
  const lower = trimmed.toLowerCase();
  return lower.includes('utm_source=') && lower.includes('utm_medium=');
}

export function utmTrackingRequirementMessage(): string {
  return 'Add {{CTA_URL}} (recommended) or include utm_source= and utm_medium= in your links so email traffic can be tracked.';
}
